import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  Input,
  ViewChild,
} from '@angular/core';
import { IAppPage } from 'src/app/views/layout/layout.component';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements AfterViewInit {
  @ViewChild('menuitems', { static: true }) private readonly _menuItems: ElementRef;

  @Input() public appPages: IAppPage[];
  @Input() public externalRefPages: IAppPage[];

  private _activeIndex = 0;
  @Input() public set activeIndex(index: number) {
    this._activeIndex = index;
    this._updateSelectedIndexBounds(this._activeIndex);
  }

  public selectedIndexTop = 0;
  public selectedIndexHeight = 0;
  public currentYear: number = new Date().getFullYear();

  @HostBinding('class.expanded')
  public isMenuExpanded = false;

  constructor(private readonly _changeDetector: ChangeDetectorRef) {}

  @HostListener('focusin')
  @HostListener('mouseenter')
  public onMouseEnter = () => (this.isMenuExpanded = true);

  @HostListener('focusout')
  @HostListener('mouseleave')
  public onMouseLeave = () => (this.isMenuExpanded = false);

  public ngAfterViewInit(): void {
    this._updateSelectedIndexBounds(this._activeIndex);
    this._changeDetector.detectChanges(); // Must be called to prevent NG0100 error
  }

  public toggleMenu() {
    this.isMenuExpanded = !this.isMenuExpanded;
  }

  private _updateSelectedIndexBounds(index: number) {
    const rect: DOMRect = this._menuItems.nativeElement.getBoundingClientRect();

    const itemHeight = Math.round(rect.height / this.appPages.length);
    this.selectedIndexTop = index * itemHeight;
    this.selectedIndexHeight = itemHeight;
  }
}
